import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";

const states = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

const activeStates = {
  Arizona: "AZ",
  California: "CA",
  Florida: "FL",
  Georgia: "GA",
  Illinois: "IL",
  Indiana: "IN",
  Michigan: "MI",
  "New York": "NY",
  "North Carolina": "NC",
  Pennsylvania: "PA",
  "South Carolina": "SC",
  Tennessee: "TN",
  Texas: "TX",
  Virginia: "VA",
  "West Virginia": "WV",
  Wisconsin: "WI",
};

const MapMobileGraph = ({
  handleApply,
  stateSelectedData,
  setStateSelectedData,
  state,
  setState,
  handleReset,
  isPortrait,
}) => {
  const activeAbbreviations = Object.values(activeStates);

  const handleToggleState = (stateCode) => {
    setStateSelectedData((prev) =>
      prev.includes(stateCode)
        ? prev.filter((s) => s !== stateCode)
        : [...prev, stateCode],
    );
  };

  const onApply = () => {
    handleApply();
  };

  const onReset = () => {
    setStateSelectedData([]);
    handleReset?.();
  };
  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: "8px",
          padding: "10px",
          background: "#F3F4F9",
        }}
      >
        {Object.entries(states).map(([stateName, stateCode]) => {
          const isActive = activeAbbreviations.includes(stateCode);
          const isSelected = stateSelectedData.includes(stateName);

          return (
            <Box
              key={stateCode}
              onClick={() => handleToggleState(stateName)}
              sx={{
                width: isPortrait ? 50 : 34,
                height: isPortrait ? 50 : 34,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: isSelected
                  ? "2px solid #E32726"
                  : isActive
                    ? "1.5px solid #E32726"
                    : "1px solid #D9D9D9",
                backgroundColor: isSelected ? "#FDECEC" : "#FFFFFF",
              }}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: isSelected ? "#E32726" : "#2C2C2C",
                }}
              >
                {stateCode}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Footer Actions */}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ px: 2, py: 1.5,
          //  borderTop: "1px solid #E0E0E0"
           }}
      >
        {/* Reset */}
        <Button
          variant="text"
          onClick={onReset}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            color: "#555",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
          }}
        >
          Reset
        </Button>

        {/* Apply */}
        <Button
          variant="contained"
          disabled={stateSelectedData.length === 0}
          onClick={onApply}
          sx={{
            backgroundColor: "#D32F2F",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 1,
            px: 3,
            "&:hover": {
              backgroundColor: "#B71C1C",
            },
          }}
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};

export default MapMobileGraph;
